module.exports = __webpack_public_path__ + "img/pro_two_4.9b9eb746.jpg";